import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { createOrder, updateOrder } from '../http/orders';
import { ORDERS_QUERY_KEY } from '../http/orders.query-keys';
import { getSuccessMessage } from '../components/orders/constants/orderMessage';
import { getInitialCreateValues } from '../components/orders/OrderForm.helpers';
import { UseFormReset } from 'react-hook-form';
import { FormValues } from '../components/orders/constants/orderForm.constants';

interface UseOrderFormMutationsProps {
  isEdit: boolean;
  reset: UseFormReset<FormValues>;
  onSuccess?: () => void;
  onSubmitSettled?: () => void;
}

export const useOrderFormMutations = ({
  isEdit,
  reset,
  onSuccess,
  onSubmitSettled,
}: UseOrderFormMutationsProps) => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateMutation } = useMutation({
    mutationFn: updateOrder,
    async onSuccess(_, variables) {
      await queryClient.invalidateQueries({ queryKey: ORDERS_QUERY_KEY.all });
      toast.success(getSuccessMessage(variables.action, isEdit));
      reset(getInitialCreateValues(null));
      onSuccess?.();
    },
    onSettled() {
      onSubmitSettled?.();
    },
  });

  const { mutateAsync: createMutation } = useMutation({
    mutationFn: createOrder,
    async onSuccess(_, variables) {
      await queryClient.invalidateQueries({ queryKey: ORDERS_QUERY_KEY.all });
      toast.success(getSuccessMessage(variables.action, isEdit));
      reset(getInitialCreateValues(null));
      onSuccess?.();
    },
    onSettled() {
      onSubmitSettled?.();
    },
  });

  return { createMutation, updateMutation };
};
